import { FormPagePropertyItemMonthDay } from 'backend';
import { FormPageInputData, MONTH_DAY_PROPERTY_INPUT_TYPE } from 'shared';
import { PropertyItemElement } from '../getPropertyItemElements';

export const getMonthDayInputValue = (
  propertyItem: FormPagePropertyItemMonthDay,
  propertyItemElement: PropertyItemElement,
): FormPageInputData => {
  switch (propertyItem.inputFormat.inputType) {
    case MONTH_DAY_PROPERTY_INPUT_TYPE.free: {
      const monthElement = propertyItemElement.month;
      const dayElement = propertyItemElement.day;
      if (
        !(monthElement instanceof HTMLInputElement) ||
        !(dayElement instanceof HTMLInputElement)
      ) {
        return {};
      }
      return {
        [propertyItem.propertyId]: {
          inputItemType: 'monthDayFree',
          month: monthElement.value,
          day: dayElement.value,
        },
      };
    }
    case MONTH_DAY_PROPERTY_INPUT_TYPE.pulldown: {
      const monthElement = propertyItemElement.month;
      const dayElement = propertyItemElement.day;
      if (
        !(monthElement instanceof HTMLSelectElement) ||
        !(dayElement instanceof HTMLSelectElement)
      ) {
        return {};
      }
      return {
        [propertyItem.propertyId]: {
          inputItemType: 'monthDayPulldown',
          month: monthElement.value,
          day: dayElement.value,
        },
      };
    }
  }
};
